import { ActionTypes } from "./types";

let INITIAL_STATE = {
  data: [],
  loading: false,
  success: false,
  error: null
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.LOADING:
      return {
        ...state,
        loading: true,
      };

    case ActionTypes.SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
      };

    case ActionTypes.ERROR:
      return {
        ...state,
        loading: false,
        data: [],
        error: action.payload
      };

    default:
      return state;
  }
}
